import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2: rewritten for Project Explore (K-5), English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Setting Up Your First Class",
    intro: "Create a class in your teacher dashboard before you add students.",
    steps: [
      "In your teacher dashboard, open Class Management in the menu.",
      "Choose Add New Class.",
      "Type a class name. You can also add a class time, the term, a grade type and a short description.",
      "Choose Create Class.",
    ],
    tip: "To change a class later, open Class Management and choose Manage on that class.",
  },
  es: {
    title: "Cómo crear tu primera clase",
    intro: "Crea una clase en tu panel de maestro antes de agregar a tus estudiantes.",
    steps: [
      "En tu panel de maestro, abre Administrar clases en el menú.",
      "Elige Agregar una clase.",
      "Escribe el nombre de la clase. También puedes agregar el horario, el período escolar, el tipo de calificación y una breve descripción.",
      "Elige Crear la clase.",
    ],
    tip: "Para cambiar una clase más adelante, abre Administrar clases y elige Administrar en esa clase.",
  },
};

export default function SettingUpYourFirstClass() {
  return <HelpArticle text={TEXT} />;
}
